<template>
  <div>
    <div>
      <aha-modal
        @hide="setPresentationNoPermission(null)"
        :title="$i18nPresenter.t('You don’t have access')"
        action-position="justify-center"
      >
        <div>
          <div>
            {{ $i18nPresenter.t(
              'Please request the presentation owner to grant you access, or switch to an account that has access.'
            ) }}
          </div>
          <br />
          <div>{{ $i18nPresenter.t('You’re logged in as') }} <b>{{ currentUser.email }}</b>.</div>
        </div>

        <template #action>
          <div class="text-right w-full">
            <aha-button
              variant="base"
              class="mr-3"
              name="switch-account"
              v-aha-click="logout"
            >
              {{ $i18nPresenter.t('Switch account') }}
            </aha-button>
            <aha-button
              name="request-access"
              v-aha-click="requestAccessPresentation"
              :submitting="isLoadingRequestAccess"
            >
              {{ $i18nPresenter.t('Request access') }}
            </aha-button>
          </div>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import util from '@/util'
import PresentationApi from '@/api/presentation'

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoadingRequestAccess: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('presentationsModule', ['requestAccessPresentationId']),
  },
  methods: {
    ...mapActions('presentationsModule', ['setPresentationNoPermission']),

    logout() {
      this.setPresentationNoPermission(null)
      util.logout()
    },

    async requestAccessPresentation() {
      if (this.isLoadingRequestAccess) return
      this.isLoadingRequestAccess = true
      await PresentationApi.requestAccessPresentation({
        presentationId: this.requestAccessPresentationId,
      })
      this.isLoadingRequestAccess = false
      this.setPresentationNoPermission(null)
      util.showToastSuccess(this.$i18nPresenter.t('Request sent. We will let you know if your request was approved.'))
    },
  },
}
</script>
